class SellingPlansWidget extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.productData = {};
    this.sellingPlanGroups = [];
    this.variants = [];
    this._productRequiresSellingPlan = false;
    this.sellingPlanId = null;
    this.price = null;
    this.compareAtPrice = null;
    this.oneTimePrice = null;
    this.oneTimeCompareAtPrice = null;
    this.oneTimePriceCents = null;
    this.promotionConfig = { active: false };
    this._currentVariantId = '';
    this.isSubscribeAndSaveVisible = true;
    this.collapse = true;
    this.subscribe= true;
    this.hide_subscribe = false;
    this.handleProductFormSubmission = this.handleProductFormSubmission.bind(this);
    if(document.querySelector('body').classList.contains('new-template-no-subscription')){
      this.isSubscribeAndSaveVisible = false;
      this.collapse = false;
      this.subscribe= false;
      this.hide_subscribe = true;
    }
    
  }

  static get observedAttributes() {
    return ['section-id', 'current-variant-id', 'product-requires-selling-plan', 'promotion-config'];
  }

  connectedCallback() {
    this.sellingPlanId = this.getAttribute('selling-plan-id');
    this.currentVariantId = this.getAttribute('current-variant-id');
    this.productData = JSON.parse(this.getAttribute('product-data') || '{}');
    this.promotionConfig = this.parsePromotionConfig(this.getAttribute('promotion-config'));
    this.sellingPlanGroups = this.productData.selling_plan_groups || [];
    this.variants = this.productData.variants || [];
    this.productRequiresSellingPlan = this.productData.requires_selling_plan;
    this.productForm = this.closest('form');
    this.productForm?.addEventListener('click', this.handleProductFormSubmission, true);
    this.productForm?.addEventListener('submit', this.handleProductFormSubmission, true);
    this.updatePrice();
    this.render();
  }

  handleSubscribeAndSaveClick(e) {}

  syncSellingPlanInput(sellingPlanId) {
    const form = this.closest('form');
    if (!form) return;

    const sellingPlanInputs = [...form.querySelectorAll('input[name="selling_plan"]')];

    if (!sellingPlanId) {
      sellingPlanInputs.forEach(input => input.remove());
      return;
    }

    const sellingPlanInput = sellingPlanInputs.shift() || document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    sellingPlanInput.value = sellingPlanId;
    sellingPlanInput.dataset.sellingPlanInput = '';
    sellingPlanInputs.forEach(input => input.remove());

    if (!sellingPlanInput.isConnected) {
      form.appendChild(sellingPlanInput);
    }
  }

  handleProductFormSubmission(event) {
    if (this.subscribe) return;

    if (event.type === 'click') {
      const submitControl = event.target.closest('button[type="submit"], input[type="submit"], [data-add-to-cart-trigger], .ajax-submit');
      if (!submitControl) return;
    }

    this.syncSellingPlanInput(null);
  }

  handleOneTimePurchaseClick(e) {
    const oneTimePurchaseSlot = this.shadowRoot.querySelector('slot[name="one-time-purchase"]');
    if (oneTimePurchaseSlot) {
      oneTimePurchaseSlot.style.display = 'block';
      const assignedElements = oneTimePurchaseSlot.assignedElements();
      if (assignedElements.length > 0) {
        assignedElements[0].style.display = 'block';
      }
    }

    this.sellingPlanId = null;
    this.syncSellingPlanInput(this.sellingPlanId);
    this.dispatchEvent(new CustomEvent('selling-plan:change', {
      bubbles: true,
      composed: true,
      detail: {
        sellingPlanId: this.sellingPlanId
      }
    }));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      switch (name) {
        case 'product-data':
          this.productData = JSON.parse(newValue || '{}');
          break;
        case 'current-variant-id':
          this._currentVariantId = newValue;
          break;
        case 'product-requires-selling-plan':
          this._productRequiresSellingPlan = newValue === 'true';
          break;
        case 'promotion-config':
          this.promotionConfig = this.parsePromotionConfig(newValue);
          break;
        default:
          this[name.replace(/-([a-z])/g, g => g[1].toUpperCase())] = newValue;
      }

      this.updatePrice();
      this.render();
    }
  }

  render() {
    const style = `
      <style>
        ul {
          list-style-type: none;
        }

        .selling_plan_app_container label[for=selling-plan-selector] {
          display: none;
        }

        .title-select {
          display: block;
          color: #000;
          font-family: Montserrat;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
        }

        .pop-up {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .popup_text {
          color: #000;
          font-family: Montserrat;
          font-size: 14px !important;
          font-style: normal;
          font-weight: 600;
          letter-spacing: normal !important;
          line-height: 20px;
          text-transform: capitalize;
          cursor: pointer;
        }

        .custom-select-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        }

        .purchase-options-select {
          width: 100%;
          height: 50px;
          margin-top: 10px;
          margin-bottom: 20px;
          padding: 0 20px;
          border: 1px solid rgba(4, 30, 66, 0.20);
          border-radius: 50px;
          background-color: #fff;
          font-family: Montserrat;
          font-size: 16px;
          cursor: pointer;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }

        .custom-arrow {
          position: absolute;
          top: 45%;
          right: 10px;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #2b2967;
          transform: translateY(-50%);
          pointer-events: none;
          z-index: 1;
        }
      </style>
    `;
    const content = this.renderSubscriptionCards();

    this.shadowRoot.innerHTML = style + this.renderSubscriptionCardsStyle() + content;

    const subscribeAndSave = this.shadowRoot.querySelector('#subscribe-collap');
    const oneTimePurchase = this.shadowRoot.querySelector('#oneTime-collap');
    subscribeAndSave?.addEventListener('click', this.handleCollapClick.bind(this));
    oneTimePurchase?.addEventListener('click', this.handleCollapClick.bind(this));
    
    this.modalLink = this.shadowRoot.querySelector('.pop-up .popup_text');
    this.modalLink?.addEventListener('click', () => {
      this.dispatchEvent(new CustomEvent('modal:open', {
        bubbles: true,
        composed: true,
        detail: {
          modalId: this.sectionId
        }
      }));
    });

    this.listenToVariantChange();
    this.listenToSellingPlanFormSelectChange();
    oneTimePurchase?.addEventListener('click', () => {
      const targetElement = this.shadowRoot.querySelector('#return-div');
      if (oneTimePurchase.checked) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }

  renderSubscriptionCardsStyle() {
    return `
      <style>
        .subscription-cards {
          margin-top: 31px;
          color: #05264d;
          font-family: Raleway, sans-serif;
        }

        .subscription-cards * {
          font-family: Raleway, sans-serif;
        }

        .subscription-cards .selling_plan_theme_integration {
          display: grid;
          gap: 24px;
        }

        .subscription-card {
          overflow: hidden;
          border: 1.5px solid #05264d;
          border-radius: 32px;
          background: #f3f2e5;
        }

        .subscription-card__summary {
          display: grid;
          grid-template-columns: 48px minmax(0, 1fr) auto;
          gap: 16px;
          align-items: center;
          padding: 16px 24px;
          cursor: pointer;
        }

        .subscription-card__radio {
          display: grid;
          width: 32px;
          height: 32px;
          margin: 0;
          border: 2px solid #05264d;
          border-radius: 50%;
          appearance: none;
          place-items: center;
          cursor: pointer;
        }

        .subscription-card__radio::before {
          width: 24px;
          height: 24px;
          align-self: center;
          justify-self: center;
          border-radius: 50%;
          background: #05264d;
          content: '';
          transform: scale(0);
        }

        .subscription-card__radio:checked::before {
          transform: scale(1);
        }

        .subscription-card__title {
          display: block;
          font-size: 20px;
          font-weight: 600;
          line-height: 1.35;
          letter-spacing: -0.4px;
        }

        .subscription-card__subtitle {
          display: block;
          margin-top: 4px;
          color: #696969;
          font-size: 12px;
          font-weight: 500;
          line-height: 1.35;
          letter-spacing: -0.24px;
        }

        .subscription-card__price {
          display: flex;
          gap: 8px;
          align-items: baseline;
          white-space: nowrap;
          font-size: 22px;
          font-variant-numeric: lining-nums;
          font-weight: 700;
        }

        /* ET-1949: Discount badge test */
        .subscription-card__badge {
          display: flex;
          align-items: center;
          align-self: center;
          justify-content: center;
          box-sizing: border-box;
          min-width: 80px;
          min-height: 20px;
          padding: 2px 4px;
          border-radius: 17px;
          background: var(--kitty-scratch-700, #b5452a);
          color: var(--primary-stone-100, #F3EFE7);
          font-family: Raleway, sans-serif;
          font-size: 12px;
          font-style: normal;
          font-variant-numeric: lining-nums;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.439px;
          text-align: center;
        }

        .subscription-card__price s {
          color: #686868;
          font-size: 17px;
          font-weight: 500;
        }

        .subscription-card__body {
          padding: 0 30px 26px;
        }

        .subscription-card__plan-heading {
          display: flex;
          gap: 20px;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 14px;
        }

        .subscription-card__plan-heading .title-select {
          flex: none;
          color: var(--Primary-Dark-Navy, #041e42);
          font-family: Raleway, sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
        }

        .subscription-card .pop-up {
          gap: 7px;
          color: #05264d;
          padding: 0;
          border: 0;
          background: transparent;
          cursor: pointer;
        }

        .subscription-card .popup_text {
          color: var(--Primary-Dark-Navy, #041e42);
          font-family: Raleway, sans-serif;
          font-size: 14px !important;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
          text-transform: capitalize;
        }

        .subscription-card .custom-select-wrapper {
          display: block;
          margin-bottom: 24px;
        }

        .subscription-card .purchase-options-select {
          overflow: hidden;
          margin: 0;
          padding: 6px 16px;
          border: 1px solid #c9ced6;
          border-radius: 28px;
          color: #000;
          text-overflow: ellipsis;
          font-family: Raleway, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 19.2px;
        }

        .subscription-card .custom-arrow {
          top: 50%;
          right: 22px;
          width: 16px;
          height: 9.2px;
          border: 0;
        }

        .subscription-card .custom-arrow svg {
          display: block;
          width: 16px;
          height: 9.2px;
        }

        .subscription-benefits {
          display: grid;
          gap: 13px;
          margin: 0;
          padding: 0;
          color: #686868;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.35;
          letter-spacing: -0.28px;
          list-style: none;
        }

        .subscription-benefits li {
          display: flex;
          gap: 8px;
          align-items: center;
        }

        .subscription-benefits svg {
          flex: none;
        }

        .subscription-benefits strong {
          font-weight: 700;
        }

        .subscription-benefits s {
          margin-left: 4px;
        }

        @media (max-width: 600px) {
          .subscription-cards {
            margin-top: 32px;
          }

          .subscription-card__summary {
            grid-template-columns: 34px minmax(0, 1fr) auto;
            gap: 8px;
            padding-right: 16px;
            padding-left: 16px;
          }

          .subscription-card__price {
            flex-direction: column-reverse;
            gap: 0;
            align-items: flex-end;
            font-size: 20px;
          }

          /* ET-1949: Discount badge test - on mobile the subtitle becomes the badge */
          .subscription-card__badge {
            display: none;
          }

          .subscription-card--badge-test .subscription-card__subtitle {
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            width: fit-content;
            min-width: 80px;
            min-height: 20px;
            padding: 2px 4px;
            border-radius: 17px;
            background: var(--kitty-scratch-700, #b5452a);
            color: var(--primary-stone-100, #F3EFE7);
            font-family: Raleway, sans-serif;
            font-size: 12px;
            font-style: normal;
            font-variant-numeric: lining-nums;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: -0.439px;
            text-align: center;
          }

          .subscription-card__price s {
            display: block;
            font-size: 14px;
          }

          .subscription-card__body {
            padding: 0 18px 22px;
          }

          .subscription-card__plan-heading {
            align-items: flex-start;
            flex-direction: column;
            gap: 8px;
          }

        }
      </style>
    `;
  }

  renderSubscriptionCards() {
    const promotion = this.promotionConfig || { active: false };
    const initialDiscountPercent = promotion.active ? promotion.initialDiscountPercent : 20;
    const ongoingDiscountPercent = promotion.active ? promotion.ongoingDiscountPercent : 20;
    const compareAtPrice = this.oneTimePrice || this.compareAtPrice || this.price;
    const compareAtPriceCents = this.oneTimePriceCents;
    const subscriptionPriceType = promotion.active ? 'initial' : 'recurring';
    const subscriptionPrice = this.getDiscountedPrice(compareAtPrice, initialDiscountPercent, compareAtPriceCents, subscriptionPriceType);
    const ongoingPrice = this.getDiscountedPrice(compareAtPrice, ongoingDiscountPercent, compareAtPriceCents, 'recurring');
    const subscriptionSelected = this.subscribe === true;
    const showDiscountBadge = this.hasAttribute('show-discount-badge') || promotion.active;
    const recurringOrderLabel = promotion.active ? 'ongoing' : 'Every Order';

    // ET-1949: Discount badge test (show-discount-badge is set by Liquid on template sl-A63566BE)
    return `
      <div id="return-div" class="selling_plan_app_container subscription-cards" data-section-id="selling-plan-section">
        <section data-variant-id="${this.currentVariantId || ''}" class="selling_plan_theme_integration">
          <div class="subscription-card${showDiscountBadge ? ' subscription-card--badge-test' : ''}" ${this.hide_subscribe ? 'style="display:none;"' : ''}>
            <label class="subscription-card__summary" for="subscribe-collap">
              <input class="subscription-card__radio" id="subscribe-collap" type="radio" name="purchase-option" ${subscriptionSelected ? 'checked' : ''}>
              <span>
                <span class="subscription-card__title">Subscribe and Save</span>
                <span class="subscription-card__subtitle">Save ${initialDiscountPercent}% when you subscribe</span>
              </span>
              <span class="subscription-card__price">${showDiscountBadge ? `<span class="subscription-card__badge">Save ${initialDiscountPercent}%</span>` : ''}<s>${compareAtPrice}</s> ${subscriptionPrice}</span>
            </label>
            ${subscriptionSelected ? `
              <div class="subscription-card__body">
                <div class="subscription-card__plan-heading">
                  <span class="title-select">Select a plan</span>
                  <button class="pop-up" type="button">
                    <span class="popup_text">How Does Subscription Work?</span>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
                      <circle cx="7.5" cy="7.5" r="6.25" fill="#05264d"/>
                      <path d="M7.5 6.7v4M7.5 4.25v.1" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  </button>
                </div>
                ${this.renderSellingPlanSelector()}
                <ul class="subscription-benefits">
                  ${promotion.active ? `
                    <li>
                      ${this.renderTagIcon()}
                      <span><strong>${this.escapeHtml(promotion.firstBenefitText)}</strong></span>
                    </li>
                  ` : ''}
                  <li>
                    ${this.renderTagIcon()}
                    <span><strong>${ongoingDiscountPercent}% Off</strong> ${recurringOrderLabel} - <s>${compareAtPrice}</s> - ${ongoingPrice}</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                      <path d="M6.875 3.75L13.125 10L6.875 16.25" stroke="#696969" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Edit, Skip or Cancel Anytime</span>
                  </li>
                  <li>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                      <path d="M11.617 10.5997C11.704 10.969 11.75 11.3541 11.75 11.75C11.75 14.5114 9.51142 16.75 6.75 16.75V12.7503M6.75 12.7503C8.54115 12.3867 10.1932 11.6401 11.617 10.5997C14.7287 8.32593 16.75 4.64895 16.75 0.5C12.6012 0.500176 8.92456 2.52155 6.65102 5.63313C5.61071 7.05689 4.86417 8.70891 4.5006 10.5C4.48306 10.5864 4.46641 10.6732 4.45066 10.7602C5.04992 11.516 5.73476 12.2008 6.49052 12.8001C6.57733 12.7844 6.66382 12.7678 6.75 12.7503ZM6.65102 5.63313C6.28148 5.54606 5.89612 5.5 5.5 5.5C2.73858 5.5 0.5 7.73858 0.5 10.5H4.5006M2.63492 12.4923C1.71845 13.176 1.125 14.2687 1.125 15.5C1.125 15.6974 1.14025 15.8912 1.16964 16.0804C1.35879 16.1098 1.55261 16.125 1.75 16.125C2.98131 16.125 4.07402 15.5316 4.7577 14.6151M12.375 6.125C12.375 6.81536 11.8154 7.375 11.125 7.375C10.4346 7.375 9.875 6.81536 9.875 6.125C9.875 5.43464 10.4346 4.875 11.125 4.875C11.8154 4.875 12.375 5.43464 12.375 6.125Z" stroke="#696969" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Free Shipping on Every Order</span>
                  </li>
                </ul>
                <slot name="subscribe-and-save-top"></slot>
              </div>
            ` : ''}
          </div>

          ${this.productRequiresSellingPlan ? '' : `
            <div class="subscription-card subscription-card--one-time">
              <label class="subscription-card__summary" for="oneTime-collap">
                <input class="subscription-card__radio" id="oneTime-collap" type="radio" name="purchase-option" ${subscriptionSelected ? '' : 'checked'}>
                <span class="subscription-card__title">One-time purchase</span>
                <span class="subscription-card__price">${this.oneTimePrice}</span>
              </label>
            </div>
          `}
        </section>
        <slot></slot>
      </div>
    `;
  }

  parsePromotionConfig(value) {
    if (!value) return { active: false };

    try {
      const config = JSON.parse(value);
      const initialDiscountPercent = Number(config.initialDiscountPercent);
      const ongoingDiscountPercent = Number(config.ongoingDiscountPercent ?? 20);
      const validInitialDiscount = Number.isFinite(initialDiscountPercent) && initialDiscountPercent >= 0 && initialDiscountPercent <= 100;
      const validOngoingDiscount = Number.isFinite(ongoingDiscountPercent) && ongoingDiscountPercent >= 0 && ongoingDiscountPercent <= 100;

      if (!config.active || !validInitialDiscount || !validOngoingDiscount) {
        return { active: false };
      }

      return {
        active: true,
        initialDiscountPercent,
        ongoingDiscountPercent,
        firstBenefitText: String(config.firstBenefitText || `Black Friday ${initialDiscountPercent}% Off 1st month`)
      };
    } catch (error) {
      console.warn('Invalid subscription promotion configuration.', error);
      return { active: false };
    }
  }

  escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  renderTagIcon() {
    return `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M7.97335 2.5H4.375C3.33947 2.5 2.5 3.33947 2.5 4.375V7.97335C2.5 8.47063 2.69754 8.94754 3.04917 9.29917L11.0334 17.2834C11.6157 17.8657 12.5166 18.0098 13.2054 17.5587C14.9392 16.4237 16.4237 14.9392 17.5587 13.2054C18.0098 12.5166 17.8657 11.6157 17.2834 11.0334L9.29917 3.04917C8.94754 2.69754 8.47063 2.5 7.97335 2.5Z" stroke="#696969" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 5H5.00625V5.00625H5V5Z" stroke="#696969" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  handleCollapClick() {
    this.collapse = !this.collapse;
    this.subscribe = !this.subscribe;
    if(this.subscribe !== true){
      this.render()
      this.handleOneTimePurchaseClick();
    } else {
      this.sellingPlanId = this.getAttribute('selling-plan-id');
      this.syncSellingPlanInput(this.sellingPlanId);
      this.dispatchEvent(new CustomEvent('selling-plan:change', {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlanId: this.sellingPlanId
        }
      }));
      this.updatePrice();
      this.render();
    }
  };

  renderSellingPlanSelector() {
    const sellingPlanGroups = this.sellingPlanGroups || [];
    return sellingPlanGroups.map(group => this.renderSellingPlanGroup(group)).join('');
  }

  renderSellingPlanGroup(group) {
    const variantAllocations = this.getVariantData(this.currentVariantId).sellingPlanAllocations || [];
    const sellingPlanAllocations = variantAllocations.filter(allocation => allocation.sellingPlanGroupId === group.id);
    sellingPlanAllocations.forEach(plan => {
      plan.sellingPlanName = plan.sellingPlanName.replace(/Get \d+(?:\.\d+)?% off today and all future orders\./i, "").trim();
    });
    return ` 

    <div class="custom-select-wrapper">
        <select class="purchase-options-select">
            ${sellingPlanAllocations.map(sellingPlanAllocation => this.renderSellingPlan(sellingPlanAllocation)).join('')}
        </select>
        <div class="custom-arrow">
          <svg width="16" height="9.2" viewBox="0 0 16 10" fill="none" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.351472 0.351472C0.820101 -0.117157 1.5799 -0.117157 2.04853 0.351472L8 6.30294L13.9515 0.351473C14.4201 -0.117156 15.1799 -0.117156 15.6485 0.351473C16.1172 0.820102 16.1172 1.5799 15.6485 2.04853L8.84853 8.84853C8.62348 9.07357 8.31826 9.2 8 9.2C7.68174 9.2 7.37651 9.07357 7.15147 8.84853L0.351472 2.04853C-0.117157 1.5799 -0.117157 0.820101 0.351472 0.351472Z" fill="#041E42"/>
          </svg>
        </div>
    </div>
      `;
  }


  getDiscountedPrice(price, discountPercent, priceCents, priceType = 'initial') {
	  if (!price) return '';

	  const originalPriceCents = Number(priceCents);
	  const normalizedDiscount = Number(discountPercent);

	  if (!Number.isInteger(originalPriceCents) || !Number.isFinite(normalizedDiscount)) return price;

	  let discountedPriceCents;
	  if (priceType === 'recurring') {
	    // Ordergroove recurring prices round the calculated final price to the nearest cent.
	    discountedPriceCents = Math.round(originalPriceCents * (100 - normalizedDiscount) / 100);
	  } else {
	    // Shopify initial discounts round down the per-unit discount, then subtract it.
	    const discountAmountCents = Math.floor(originalPriceCents * normalizedDiscount / 100);
	    discountedPriceCents = originalPriceCents - discountAmountCents;
	  }

	  const discountedPrice = discountedPriceCents / 100;

	  return new Intl.NumberFormat('en-US', {
	    style: 'currency',
	    currency: 'USD'
	  }).format(discountedPrice);
	}

	renderSellingPlan(allocation) {
	  const sellingPlanId = String(allocation.sellingPlanId);
	  const currentSellingPlanId = String(this.sellingPlanId || '');
	  const compareAtPrice = allocation.compareAtPrice || allocation.price;
	  const compareAtPriceCents = allocation.compareAtPriceCents || allocation.priceCents;
	  const promotion = this.promotionConfig || { active: false };
	  const initialDiscountPercent = promotion.active ? promotion.initialDiscountPercent : 20;
	  const subscriptionPriceType = promotion.active ? 'initial' : 'recurring';
	  const subscriptionPrice = this.getDiscountedPrice(compareAtPrice, initialDiscountPercent, compareAtPriceCents, subscriptionPriceType);

	  return `
	    <option 
	      value="${sellingPlanId}"
	      ${sellingPlanId === currentSellingPlanId ? 'selected' : ''}
	      data-selling-plan-id="${sellingPlanId}"
	      data-selling-plan-group-id="${allocation.sellingPlanGroupId}"
	      data-variant-price="${subscriptionPrice}"
	      data-variant-compare-at-price="${compareAtPrice}"
	    >
	      ${allocation.sellingPlanName} - ${subscriptionPrice}
	    </option>
	  `;
	}

	handleSellingPlanChange(sellingPlanId) {
	  this.sellingPlanId = String(sellingPlanId);
    this.syncSellingPlanInput(this.sellingPlanId);

	  this.dispatchEvent(new CustomEvent('selling-plan:change', {
	    bubbles: true,
	    composed: true,
	    detail: {
	      sellingPlanId: this.sellingPlanId
	    }
	  }));

	  this.updatePrice();
	  this.render();
	}

  listenToVariantChange() {
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  listenToSellingPlanFormSelectChange() {
    const sellingPlansSelector = this.shadowRoot.querySelector('select.purchase-options-select');
    sellingPlansSelector?.addEventListener('change', event => {
      const sellingPlanId = sellingPlansSelector.options[sellingPlansSelector.selectedIndex].value;
      this.handleSellingPlanChange(sellingPlanId)
    })
  }

 handleVariantChange(evt) {
  this.variantId = evt.detail.variant.id;
  this.updatePrice();
  this.setAttribute('current-variant-id', this.variantId);
  
  // Dispatch a more detailed variant change event for price updates
  this.dispatchEvent(new CustomEvent('variant:change', {
    bubbles: true,
    composed: true,
    detail: {
      variant: {
        id: this.variantId,
        // Add any other variant properties needed
      }
    }
  }));
}

	updatePrice() {
	  const variantData = this.getVariantData(this.currentVariantId);

	  if (variantData) {
	    if (this.sellingPlanId) {
	      const allocation = variantData.sellingPlanAllocations.find(
	        a => String(a.sellingPlanId) === String(this.sellingPlanId)
	      );

	      if (allocation) {
	        this.price = allocation.price;
	        this.compareAtPrice = allocation.compareAtPrice;
	      }
	    } else {
	      this.price = variantData.price;
	      this.compareAtPrice = variantData.compareAtPrice;
	    }

	    this.oneTimePrice = variantData.price;
	    this.oneTimeCompareAtPrice = variantData.compareAtPrice;
	    this.oneTimePriceCents = Number(variantData.priceCents);
	  }
	}

  getVariantData(variantId) {
    const scriptElement = this.querySelector(`script[data-variant-id="${variantId}"]`);
    return scriptElement ? JSON.parse(scriptElement.textContent || '{}') : null;
  }

  get currentVariantId() {
    return this._currentVariantId;
  }

  set currentVariantId(value) {
    this._currentVariantId = value;
  }

  get productRequiresSellingPlan() {
    return this._productRequiresSellingPlan;
  }

  set productRequiresSellingPlan(value) {
    this._productRequiresSellingPlan = value;
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener('click', this.handleProductFormSubmission, true);
    this.productForm?.removeEventListener('submit', this.handleProductFormSubmission, true);
  }
}

customElements.define('selling-plans-widget', SellingPlansWidget);


document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('selling-plan:change', (event) => {
    const sellingPlanId = event.detail.sellingPlanId;
    const form = event.target.closest('form') || document.querySelector('form.product-single__form');

    if (form) {
      const sellingPlanInput = form.querySelector(`input[name="selling_plan"]`);

      if (!sellingPlanId) {
        sellingPlanInput?.remove();
      } else if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
      } else {
        const newSellingPlanInput = document.createElement('input');
        newSellingPlanInput.type = 'hidden';
        newSellingPlanInput.name = 'selling_plan';
        newSellingPlanInput.value = sellingPlanId;
        newSellingPlanInput.dataset.sellingPlanInput = '';
        form.appendChild(newSellingPlanInput);
      }
    }
  });

  document.querySelector('selling-plans-widget').querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const form = document.querySelector('.product-single__form');
      if (form) {
        const submitEvent = new Event('submit', {bubbles: true,cancelable: true,});
        form.dispatchEvent(submitEvent);
      }
    });

  });

  document.addEventListener('variant:change', event => {
    if (event.detail.index === "option1") {
      document.querySelectorAll('.button-dog').forEach(button => {
        if (button.dataset.value === event.detail.value) {
          button.classList.add('button-selected');
        } else {
          button.classList.remove('button-selected');
        }
      });
    }
  });
});
